<template>
  <div :class="['product-delivery-selector', `product-delivery-selector--${selectorSize}`]">
    <button
      class="product-variation-selector__button"
      :class="isSelected('buy-out')"
      key="buy-out"
      @click.prevent="changeSelected('buy-out')"
    >
      <span class="product-delivery-selector__button-text">Buy Out</span>
      <span v-if="buyOutBadge" class="product-delivery-selector__badge">{{ buyOutBadge }}</span>
    </button>
    <button
      class="product-variation-selector__button"
      :class="isSelected('subscription')"
      key="subscription"
      @click.prevent="changeSelected('subscription')"
    >
      <span class="product-delivery-selector__button-text">Subscription</span>
      <span v-if="subscriptionBadge" class="product-delivery-selector__badge">{{ subscriptionBadge }}</span>
    </button>
  </div>
</template>

<script>

export default {
  props: {
    selectorSize: {
      type: String,
      default: 'medium'
    },
    buyOutBadge: {
      type: String,
      default: null
    },
    subscriptionBadge: {
      type: String,
      default: null
    },
  },
  data() {
    return {
      selectedOption: 'buy-out',
    }
  },
  methods: {
    isSelected(selectorName) {
      return {
        'product-variation-selector__button--selected': this.selectedOption === selectorName,
      };
    },
    changeSelected(selectedOption) {
      this.selectedOption = selectedOption
      this.$emit('selected-delivery-changed', selectedOption)
    },
  },
}
</script>

<style lang="scss">
.product-delivery-selector {
  display: flex;
  justify-content: space-evenly;
  gap: 0.3rem;
  margin-top: 0.7rem;

  &__button {
    align-items: center;
    border-radius: 2rem;
    border: 1px solid #000;
    display: flex;
    flex-grow: 1;
    gap: 0.4rem;
    justify-content: center;
    padding: 0.5rem 1rem;
    transition: color .25s, background-color .25s;

    &--selected {
      background-color: #000;
      color: #fff;
    }
  }

  &__button-text {
    flex-shrink: 1;
  }

  &__dropdown-selector {
    border: solid 1px;
    padding: 0.5rem 1rem;
    border-radius: 2rem;
    text-align: left;

    &--badge {
      background-color: var(--color-orange);
      font-weight: bold;
    }
  }

  &__badge {
    align-items: center;
    background-color: var(--color-orange);
    border-radius: 0.3rem;
    color: #fff;
    display: flex;
    flex-shrink: 0;
    font-size: 0.65rem;
    font-weight: bold;
    padding: 0.15rem 0.3rem;
  }
}
</style>